module.exports = __webpack_public_path__ + "static/news-default-90e67acf82f09aafb9f660a59f2faee7.jpg";